import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab, Toolbar, Typography } from "@mui/material";
import React, { useState } from "react";
import { Group } from "../../components/Ordering/Group/Group";
import { Product } from "../../components/Ordering/Product";

export const Ordering = () => {
	const [value, setValue] = useState("0");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const tabs = [
		{ tab: "Groups", context: <Group /> },
		{ tab: "Products", context: <Product /> },
	];
	return (
		<Box sx={{ px: 5, pt: 5 }}>
			<Toolbar disableGutters>
				<Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>
					Ordering Playoff Groups & Products
				</Typography>
			</Toolbar>

			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList
						onChange={handleChange}
						aria-label="lab API tabs example"
					>
						{tabs.map(({ tab }, index) => (
							<Tab
								key={`tab-${index}`}
								label={`${tab}`}
								value={index.toString()}
							/>
						))}
					</TabList>
				</Box>

				<Box sx={{ flexGrow: 1 }}>
					{tabs.map(({ context }, index) => (
						<TabPanel
							value={index.toString()}
							key={`tab-panel-${index}`}
						>
							{context}
						</TabPanel>
					))}
				</Box>
			</TabContext>
		</Box>
	);
};
